import React from "react";
import { InputJson } from "../../nq-component";
import CollectionFormPresenter from "./CollectionFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import FormFactory from "../../components/FormFactory";

class CollectionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const { navigate } = this.props;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <div
          className="overflow-auto"
          style={{ 
            backgroundColor: '#EDEEF0',
            minHeight: '100vh'
          }}
        >
          <div className="h-100">
            <div className="p-3 p-xl-4">
              <div className="d-flex flex-column gap-4">
                {/* Header Section */}
                <div className="d-flex flex-column gap-1">
                  <div className="d-flex gap-3 align-items-center">
                    <button
                      className="btn btn-link p-0 d-flex align-items-center justify-content-center"
                      onClick={() => navigate(-1)}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '8px',
                        color: '#283754',
                        textDecoration: 'none',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f8f9fa';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <i className="bi bi-chevron-left" style={{ fontSize: '1.25rem' }}></i>
                    </button>
                    <h2 
                      className="m-0 fw-bold text-capitalize"
                      style={{ 
                        color: '#283754',
                        fontSize: '1.75rem',
                        letterSpacing: '-0.02em'
                      }}
                    >
                      {label} Collection
                    </h2>
                  </div>
                </div>

                {/* Form Card */}
                <div
                  className="bg-white rounded-3 shadow-sm"
                  style={{ 
                    padding: '1.5rem',
                    border: '1px solid #e9ecef'
                  }}
                >
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3 text-black">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                      />
                    )}
                  </div>
                  <div className="mt-4 ">
                    <button
                      type="button"
                      className=" fs-sm me-3 rounded-1 border border-1"
                      style={{ background: "#DADBE0" }}
                      onClick={this.onClickBack.bind(this)}
                    >
                      CANCEL
                    </button>
                    <button
                      type="submit"
                      className="fs-sm me-3 text-white rounded-1 border border-1"
                      style={{ background: "#14213D" }}
                    >
                      <i className="bi bi-check me-2"></i>ADD
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        </div>
        {this.renderPreviewModal()}
      </>
    );
  }
}


export default withRouter(CollectionFormPage);
